<script lang="ts" setup>
import Checkbox from 'primevue/checkbox';
import type {
  CheckboxSize,
  CheckboxVariant,
} from '~/types/components/base/Checkbox';

/**
 * https://primevue.org/checkbox/#api.checkbox.props
 */
const {
  name = undefined,
  value = undefined,
  variant = undefined,
  size = undefined,

  disabled = false,
  loading = false,
  indeterminate = false,
  invalid = false,
} = defineProps<{
  name?: string;
  value?: unknown;
  variant?: CheckboxVariant;
  size?: CheckboxSize;

  disabled?: boolean;
  loading?: boolean;
  indeterminate?: boolean;
  invalid?: boolean;
}>();
</script>

<template>
  <Checkbox
    :name="name"
    :value="value"
    :variant="variant"
    :size="size"
    :disabled="disabled"
    :loading="loading"
    :indeterminate="indeterminate"
    :invalid="invalid"
    class="app-checkbox"
  />
</template>

<style lang="scss" scoped>
.app-checkbox {
}
</style>
